export default "__VITE_ASSET__DFBIVzev__"